<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2199_5007)">
<path d="M15.9831 31.9662C24.8103 31.9662 31.9662 24.8103 31.9662 15.9831C31.9662 7.15588 24.8103 0 15.9831 0C7.15588 0 0 7.15588 0 15.9831C0 24.8103 7.15588 31.9662 15.9831 31.9662Z" fill="#480D93"/>
<path d="M16 6C16.6904 6 17.25 6.55964 17.25 7.25V14.75H24.75C25.4404 14.75 26 15.3096 26 16C26 16.6904 25.4404 17.25 24.75 17.25H17.25V24.75C17.25 25.4404 16.6904 26 16 26C15.3096 26 14.75 25.4404 14.75 24.75V17.25H7.25C6.55964 17.25 6 16.6904 6 16C6 15.3096 6.55964 14.75 7.25 14.75H14.75V7.25C14.75 6.55964 15.3096 6 16 6Z" fill="white"/>
</g>
<defs>
<clipPath id="clip0_2199_5007">
<rect width="32" height="32" fill="white"/>
</clipPath>
</defs>
</svg>
